// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import { StyledNav } from "@insite/mobius/Breadcrumbs";
import Page, { PageProps } from "@insite/mobius/Page";
import XngAppProvider from "@vanmeter/App/Components/XngAppProvider/XngAppProvider";
import { hideElementOnPrint, layoutContainer } from "@vanmeter/XDL/Utilities";
import * as React from "react";
import { ReactNode } from "react";
import styled, { css } from "styled-components";

interface PageLayoutProps {
    showHeader: boolean;
    header: ReactNode;
    showCompactHeader: boolean;
    compactHeader: ReactNode;
    showBreadcrumbs: boolean;
    pageContent: ReactNode;
    showFooter: boolean;
    footer: ReactNode;
    showSignInOverlay?: boolean;
    signInOverlay?: ReactNode;
}

// <XNG-Changes>
export interface PageLayoutStyles {
    breadcrumbs?: PageProps;
}

export const pageLayoutStyles: PageLayoutStyles = {
    breadcrumbs: {
        fullWidth: [true, true, true, true, true],
        background: "common.ui14",
        css: css`
            ${hideElementOnPrint}
            & > ${StyledNav} {
                padding-block: 8px;
                ${layoutContainer}
            }
        `,
    },
};
// </XNG-Changes>

// This doesn't currently support HMR
const PageLayout = ({
    showHeader,
    header,
    showBreadcrumbs,
    pageContent,
    showFooter,
    footer,
    showCompactHeader,
    compactHeader,
    showSignInOverlay,
    signInOverlay,
}: PageLayoutProps) => {
    return (
        <PageLayoutWrapper>
            {/* XNG-Changes: add XngAppProvider */}
            <XngAppProvider>
                {showHeader && header}
                {showCompactHeader && compactHeader}
                {showBreadcrumbs && (
                    // XNG-Changes: add styles
                    <Page as="div" {...pageLayoutStyles.breadcrumbs}>
                        <PageBreadcrumbs />
                    </Page>
                )}
                {pageContent}
                {showFooter && footer}
                {showSignInOverlay && signInOverlay}
                <CookiePrivacyPolicyPopup />
            </XngAppProvider>
        </PageLayoutWrapper>
    );
};

const PageLayoutWrapper = styled.div`
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    > main {
        flex: 1 1 0%;
    }

    @media print {
        display: block;
    }
`;

export default PageLayout;
